module.exports = __webpack_public_path__ + "img/pic3.f6e5c94f.png";